<template>
    <div>
        <b-modal v-model="showModal" title="Share" modal-class="modal-a" hide-footer hide-header centered>
            <b-form>
                <b-form-group
                    class="mb-3"
                    description=""
                    label="Email"
                    label-for="emailField"
                    :invalid-feedback="form.errors.get('email')"
                    :state="!form.errors.has('email')"
                >
                    <b-form-input type="text" id="emailField" v-model="form.email" :disabled="form.busy"></b-form-input>
                </b-form-group>
                <b-form-group
                    class="mb-3"
                    label="Message"
                    label-for="contentField"
                    description=""
                    :invalid-feedback="form.errors.get('content')"
                    :state="!form.errors.has('content')"
                >
                    <b-form-textarea id="contentField" v-model="form.content" placeholder="Message" :rows="3" :disabled="form.busy"></b-form-textarea>
                </b-form-group>
                <b-form-group class="mb-3">
                    <button class="btn btn-secondary" @click="submit">
                        Submit
                    </button>
                    <button class="btn btn-cancel" @click="cancelModal">
                        Cancel
                    </button>
                </b-form-group>
            </b-form>
        </b-modal>
        <portal to="shareTeamScheduleModal">
            <button @click.prevent="showModal = true" title="Share Schedule">
                <i class="fal fa-share-alt fa-fw"></i>
            </button>
        </portal>
    </div>
</template>

<script>
export default {
    props: {
        teamScheduleId: {
            required: true,
        },
    },
    data() {
        return {
            showModal: false,
            form: new SparkForm({
                email: null,
                content: null,
            }),
        };
    },
    methods: {
        clearForm() {
            this.form.content = null;
            this.form.email = null;
            this.showModal = true;
        },
        submit() {
            const _this = this;
            Spark.post(`/api/team/team-schedules/${this.teamScheduleId}/share`, this.form).then(() => {
                _this.clearForm();
                _this.showModal = false;
                _this.$noty.success('Shared');
            });
        },
        cancelModal() {
            this.showModal = false;
        },
    },
};
</script>
